export const TeenPatti2020 = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 48 48"
    >
        <path
            className="ico_pri"
            d="M9.345 12.056a1 1 0 0 0-.707 1.225L13.7 32.172v.018a5 5 0 0 0 1.6 3.62 5.11 5.11 0 0 0 1.108.774l-.458.122a2.993 2.993 0 0 1-3.67-2.116L6.71 13.81c-.21-.78-.1-1.58.3-2.28.4-.7 1.05-1.19 1.82-1.4l5.26-1.41c-.15.36-.25.73-.31 1.12l-.004.027a5.18 5.18 0 0 0-.076.783v.24l-4.355 1.166Z"
        />
        <path
            className="ico_pri"
            d="m13.7 14.923-.97-1.523-1.37.37-.26 6.057-.01.003.01.01v-.013l.95-.257.057-1.293 1.593-.428v-.932l-1.551.417.125-2.842L13.7 16.71v-1.788ZM31.84 7.65H18.696a2.96 2.96 0 0 0-2.606 1.58c-.19.34-.31.72-.35 1.13a.931.931 0 0 1-.014.143c-.008.05-.016.1-.016.157v21.52c0 .91.41 1.71 1.05 2.26.09.08.18.16.29.23l.06-.33.14-.82.45-2.563V10.65a1 1 0 0 1 1-1h13.13a1 1 0 0 1 1 1v.698l.01.002 1.99.358V10.65a3 3 0 0 0-.115-.825A3.012 3.012 0 0 0 31.84 7.68v-.03Z"
        />
        <path
            className="ico_pri"
            d="m21.617 12.066-.097-.306H20.1l-1.83 5.79h1l.394-1.25h.62l.16-.91h-.493l.85-2.693.157.493c.172-.407.395-.785.659-1.124Z"
        />
        <path
            className="ico_pri"
            fillRule="evenodd"
            d="M25.733 14.137a1 1 0 0 0-1.158.811l-3.737 21.193a1 1 0 0 0 .811 1.159l12.93 2.28a1 1 0 0 0 1.16-.812l3.736-21.193a1 1 0 0 0-.81-1.158l-12.931-2.28Zm-3.128.464a3 3 0 0 1 3.476-2.434l12.93 2.28a3 3 0 0 1 2.434 3.476l-3.737 21.193a3 3 0 0 1-3.475 2.433l-12.931-2.28a3 3 0 0 1-2.433-3.475L22.605 14.6Z"
            clipRule="evenodd"
        />
        <path
            className="ico_pri"
            d="M32.41 26.46c-.82-.15-1.63.12-2.19.66-.07.06-.17.05-.21-.04a2.494 2.494 0 0 0-2.31-1.4c-.99.01-1.91.66-2.26 1.58-.4 1.04-.08 2.1.64 2.76.49.53 1.96 2.17 2.58 3.37.13.25.46.31.67.12 1.01-.93 3.01-1.99 3.61-2.3.76-.33 1.34-1.02 1.48-1.91a2.5 2.5 0 0 0-2.02-2.84h.01Zm-8.46-4.58 2.8-5.39 1.4.25.79 6.02-.98-.17-.73-5.41.21.04-2.51 4.83-.98-.17Zm1.22-1.06.16-.89 3 .53-.16.89-3-.53Z"
        />
    </svg>
);
